import { useParams } from "react-router-dom";
import { PageHead } from "../GtaxShell";
import { LEGAL } from "../legal";

export default function GtaxLegal({ doc }) {
  const params = useParams();
  const d = LEGAL[doc || params.doc];
  return (
    <div data-testid={`gtax-legal-${doc}`}>
      <PageHead eyebrow={d.eyebrow} title={d.title} sub="DFI Holdings · GTA X — Gold Trading Association · Version 1.0, October 2026" />
      <section className="pb-28">
        <div className="gx-wrap max-w-4xl gx-legal space-y-10">
          {d.sections.map(([h, p]) => (
            <div key={h} className="gx-line pt-8">
              <h2 className="gx-caps text-xl">{h}</h2>
              <p className="mt-4 text-[color:var(--mute)]">{p}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
